import React from 'react';

const Footer = () => {
    return (
        <div className="py-4 bg-navy text-light" />
    );
};

export default Footer;